import React from 'react';
//import { useNavigate } from "react-router-dom";


import {
    formatError,
    login,
    runLogoutTimer,
    saveTokenInLocalStorage,
    signUp,
} from '../../services/AuthService';


export const SIGNUP_CONFIRMED_ACTION = '[signup action] confirmed signup';
export const SIGNUP_FAILED_ACTION = '[signup action] failed signup';
export const LOGIN_CONFIRMED_ACTION = '[login action] confirmed login';
export const LOGIN_FAILED_ACTION = '[login action] failed login';
export const LOADING_TOGGLE_ACTION = '[Loading action] toggle loading';
export const LOGOUT_ACTION = '[Logout action] logout action';



export function signupAction(email, password, navigate) {
    return (dispatch) => {
        signUp(email, password)
        .then((response) => {
            saveTokenInLocalStorage(response.data);
            runLogoutTimer(
                dispatch,
                response.data.expiresIn * 1000
            );
            dispatch(confirmedSignupAction(response.data));
            navigate('/trades');
        })
        .catch((error) => {
            const errorMessage = formatError(error.response.data);
            dispatch(signupFailedAction(errorMessage));
        });
    };
}

export function Logout(navigate) {
	console.log('🚪 [Logout] Starting logout process...');
	console.trace('🚪 [Logout] Call stack:');
	
	// Clear all auth-related localStorage items
	console.log('🚪 [Logout] Clearing localStorage...');
	localStorage.removeItem('userDetails');
	localStorage.removeItem('access_token');
	localStorage.removeItem('expiresIn');
	localStorage.removeItem('tokenType');
	localStorage.removeItem('expirationDate');
	console.log('🚪 [Logout] localStorage cleared');
	
	if (navigate) {
		console.log('🚪 [Logout] Navigating to /login');
		navigate('/login');
	}

	console.log('🚪 [Logout] Dispatching LOGOUT_ACTION');
	return {
        type: LOGOUT_ACTION,
    };
}

export function loginAction(email, password, navigate, rememberMe = false) {
    return (dispatch) => {
        console.log('🔵 [loginAction] Starting login...', { email, rememberMe });
        login(email, password)
            .then((response) => { 
                console.log('✅ [loginAction] Login successful, response:', response.data);
                // Expecting { access_token, expiresIn }
                const payload = response.data || {};
                
                // Calculate timer: 30 days default, 1 year if "Remember me" is checked
                const timerDays = rememberMe ? 365 : 30;
                // Calculate directly in milliseconds: days * hours * minutes * seconds * milliseconds
                let timerMs = timerDays * 24 * 60 * 60 * 1000;
                
                // TEMPORAL: Force minimum 100 seconds for debugging
                if (timerMs < 100 * 1000) {
                    console.warn('⏰ [loginAction] Timer too short, forcing to 100 seconds:', timerMs);
                    timerMs = 100 * 1000;
                }
                
                // Calculate expiresIn in seconds for localStorage
                const timerSeconds = timerDays * 24 * 60 * 60;
                payload.expiresIn = timerSeconds;
                
                console.log('⏰ [loginAction] Timer calculation:', {
                    rememberMe: rememberMe,
                    timerDays: timerDays,
                    timerMs: timerMs,
                    timerSeconds: timerSeconds,
                    timerHours: timerMs / (1000 * 60 * 60),
                    timerDaysFromMs: timerMs / (1000 * 60 * 60 * 24)
                });
                
                console.log('💾 [loginAction] Saving token to localStorage:', { 
                    access_token: payload.access_token ? 'present' : 'missing', 
                    expiresIn: payload.expiresIn,
                    rememberMe: rememberMe,
                    timerDays: timerDays
                });
                saveTokenInLocalStorage(payload);
                
                console.log('⏰ [loginAction] RIGHT BEFORE calling runLogoutTimer:', {
                    timerMs: timerMs,
                    timerMsType: typeof timerMs,
                    timerMsValue: timerMs,
                    timerMsIsValid: !isNaN(timerMs) && isFinite(timerMs) && timerMs > 0,
                    timerMsInSeconds: timerMs / 1000,
                    timerMsInHours: timerMs / (1000 * 60 * 60)
                });
                
                runLogoutTimer(
                    dispatch,
                    timerMs,
                    navigate,
                );
                
                console.log('⏰ [loginAction] RIGHT AFTER calling runLogoutTimer, timerMs was:', timerMs);
                // Dispatch the action first
                console.log('📤 [loginAction] Dispatching loginConfirmedAction with payload:', payload);
                dispatch(loginConfirmedAction(payload));
                
                // Navigate after dispatch - use requestAnimationFrame to ensure
                // Redux state has been updated and component has re-rendered
                console.log('🧭 [loginAction] Scheduling navigation to /trades...');
                requestAnimationFrame(() => {
                    console.log('🧭 [loginAction] Executing navigation to /trades now');
                    navigate('/trades', { replace: true });
                });
            })
            .catch((error) => {
                console.error('❌ [loginAction] Login failed:', error);
                const errorMessage = error?.response?.data?.detail || 'Login failed';
                dispatch(loginFailedAction(errorMessage));
            });
    };
}

export function loginFailedAction(data) {
    return {
        type: LOGIN_FAILED_ACTION,
        payload: data,
    };
}

export function loginConfirmedAction(data) {
    return {
        type: LOGIN_CONFIRMED_ACTION,
        payload: data,
    };
}

export function confirmedSignupAction(payload) {
    return {
        type: SIGNUP_CONFIRMED_ACTION,
        payload,
    };
}

export function signupFailedAction(message) {
    return {
        type: SIGNUP_FAILED_ACTION,
        payload: message,
    };
}

export function loadingToggleAction(status) {
    return {
        type: LOADING_TOGGLE_ACTION,
        payload: status,
    };
}
